"use client"

import Image from "next/image"

import footerlogo from "@/assets/footerlogo.png"

export default function FooterImg() {
  const handleClick = () => {
    window.open(
      "https://chromewebstore.google.com/detail/snaptheprice/hlnhhamckimoaiekbglafiebkfimhapb",
      "_blank"
    )
  }
  return (
    <Image
      onClick={handleClick}
      src={footerlogo}
      alt="snaptheprice"
      unoptimized
      width={209}
      height={56}
      priority
      className="chromestore cursor-pointer"
    />
  )
}
